export const SETTINGS_ANNOUNCEMENT_GET_ALL = "SETTINGS_ANNOUNCEMENT_GET_ALL";
export const SETTINGS_ANNOUNCEMENT_ADDNEW = "SETTINGS_ANNOUNCEMENT_ADDNEW";
export const SETTINGS_ANNOUNCEMENT_UPDATE = "SETTINGS_ANNOUNCEMENT_UPDATE";
export const SETTINGS_ANNOUNCEMENT_DELETE = "SETTINGS_ANNOUNCEMENT_DELETE";
export const SETTINGS_PAYMENT_BESOFT_UPDATE = "SETTINGS_PAYMENT_BESOFT_UPDATE";
export const SETTINGS_GET_ALL = "SETTINGS_GET_ALL";